<template>
  <div>
    <client-list ref="clientList" v-show="tabType === 1" @handleShow="handleShow" />
    <client-show v-if="tabType === 2" :rowId="id" @handleShow="handleShow"/>
  </div>
</template>

<script>
import clientList from './list.vue'
import clientShow from './detail.vue'
export default {
  components: { clientList,clientShow },
  data() {
    return {
      tabType: 1,
      id: null,
      technicalState:null
    }
  },
  methods: {
    handleShow(id, type) {
      this.tabType=type
      this.id = id
      if (this.tabType === 1) {
        this.refreshList()
      }
    },
    // 编辑/审核完返回列表时主动重拉。
    // 这些容器是"单路由 + 内部 tab"写法：列表用 v-show、子页用 v-if，
    // 列表组件**从头到尾不销毁**，返回时既不重建也不重新请求，所以行数据和汇总卡片都是旧的。
    // 不改成 v-if 是因为那会连筛选条件和页码一起丢掉，返回就跳回第 1 页。
    // doQueryList({}) 不传 pageNo/pageSize —— 组件内是 `if (pageNo)` 才覆盖，
    // 所以当前页码和筛选条件都保留，只是重新拉一次。
    refreshList() {
      this.$nextTick(() => {
        const list = this.$refs.clientList
        if (list && list.doQueryList) {
          list.doQueryList({})
        }
      })
    }
  }
}
</script>

<style>

</style>
